import type { IUsageFeeTier } from '../types';

import { MAX_PRICE_RANGE } from '../constants';
import { formatToDollarShort } from '~/utils';

export const getRevenueRangeLabel = (revenueRange: IUsageFeeTier | undefined) => {
  if (!revenueRange) return '';

  const from = formatToDollarShort(revenueRange.min);
  const to = revenueRange.max === MAX_PRICE_RANGE ? '∞' : formatToDollarShort(revenueRange.max);

  return `${from} - ${to}`;
};
